export function buildExcludedSiblingValues(
  allRows: Record<string, unknown>[] | undefined,
  currentIndex: number,
  watchFields: string[],
): Record<string, unknown[]> {
  if (!allRows?.length || watchFields.length === 0) return {};

  const excluded: Record<string, unknown[]> = {};
  for (const fieldName of watchFields) {
    excluded[fieldName] = [];
    for (let i = 0; i < allRows.length; i++) {
      if (i === currentIndex) continue;
      const val = allRows[i]?.[fieldName];
      if (val != null && val !== '') {
        excluded[fieldName].push(val);
      }
    }
  }
  return excluded;
}
